import { render, staticRenderFns } from "./ContractTemplates.vue?vue&type=template&id=58f0d4fb&"
import script from "./ContractTemplates.vue?vue&type=script&lang=ts&"
export * from "./ContractTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports